import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { adminUpdatePreApprovedData } from "@/lib/api";

const FIELDS = [["ssn", "SSN", "font-mono"], ["store_sqft", "Store SQFT", ""], ["rent", "Monthly Rent", ""],
  ["ein", "EIN", "font-mono"], ["start_date", "Start Date", ""], ["referred_by", "Referred by", ""]];

export const DealerInfoFields = ({ dealerId, data, canEdit, onSaved }) => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setForm(Object.fromEntries(FIELDS.map(([k]) => [k, data?.[k] || ""]))); }, [data]);
  const changed = FIELDS.some(([k]) => (form[k] || "") !== (data?.[k] || ""));
  const save = async () => {
    setSaving(true);
    const body = Object.fromEntries(FIELDS.map(([k]) => [k, form[k]]).filter(([k, v]) => v !== (data?.[k] || "") && !(k === "ssn" && !v && data?.ssn_masked)));
    try { onSaved(await adminUpdatePreApprovedData(dealerId, body)); toast.success("Dealer information saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); } finally { setSaving(false); }
  };
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-2 flex-row items-center justify-between">
        <CardTitle className="text-sm font-medium text-navy">Dealer Information Fields</CardTitle>
        {canEdit && <Button size="sm" onClick={save} disabled={!changed || saving} className="bg-teal hover:bg-teal/90" data-testid="admin-dealer-info-save">
          {saving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}Save
        </Button>}
      </CardHeader>
      <CardContent className="grid grid-cols-3 gap-3">
        {FIELDS.map(([k, label, cls]) => (
          <div key={k}>
            <Label className="text-xs text-slate-500">{label}</Label>
            {canEdit ? (
              <Input type={k === "start_date" ? "date" : "text"} value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                onFocus={() => k === "ssn" && data?.ssn_masked && form.ssn === data.ssn && setForm({ ...form, ssn: "" })}
                placeholder={k === "ssn" && data?.ssn_masked ? "Type a new SSN to replace" : ""} className={`h-9 text-sm ${cls}`} data-testid={`admin-field-${k}`} />
            ) : <p className={`text-sm bg-slate-50 px-3 py-2 rounded border ${cls}`} data-testid={`admin-field-${k}`}>{data?.[k] || "—"}</p>}
          </div>
        ))}
        {data?.ssn_masked && <p className="col-span-3 text-[11px] text-slate-400">Only Super Admins can see the full SSN; you see the last 4 digits.</p>}
      </CardContent>
    </Card>
  );
};
